import Loader from "../../../components/elements/loader";
import { useWorkSelection } from "../../../hooks/react-query/useNewService";
import { validateResponse } from "../serviceUtils";

export const BookingStepOneTesla = ({ state, dispatch }) => {
  // Step One: Here the user chooses the types of services
  // he/she wants to book an appointment for.

  // LOCAL STATE:
const { mutate: workSelect, isLoading: isWorkSelectionLoading } = useWorkSelection()
  

  // FETCH DATA:

  // LOCAL VARIABLES:

  // USE EFFECTS:

  // HANDLERS & FUNCTIONS

  const stepOneTeslaHandler = async () => {
    dispatch({ type: "TOGGLE_OPTION", option: "bodyWork" });
    const payload = {
      workSelection: ["bodyWork"]
    }
    workSelect(
      {payload: payload, serviceFlowId:state?.serviceFlowId}, 
      {
        onSuccess : (response) => {
          if (validateResponse(response)) dispatch({ type: "SET_STEP", step: state.step + 1 });
        }
      })
  }


  return (
    <>
        {isWorkSelectionLoading && (
            <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/20 backdrop-blur-[2px]">
                <Loader />
            </div>
        )}
      <div className="flex flex-col gap-6 pb-10 min-w-[60%] overflow-auto items-start">
        <p className='text-lg font-bold'>Προγραμματισμός ραντεβού μέσω Tesla</p>
        <p className='text-lg'>Για αυτοκίνητα Tesla, ο προγραμματισμός ετήσιου service ή αντικατάστασης ελαστικών γίνεται αποκλειστικά μέσω της Tesla app.</p>
        <button 
            className='px-10 py-3 bg-black rounded-md text-white font-bold text-sm'
            onClick={()=>{
              const teslaUrl = `https://www.tesla.com/`
              window.open(teslaUrl, "_blank", "noopener,noreferrer");
            }}
            >
            Άνοιγμα στην Ιστοσελίδα Tesla
        </button>
        <img
            className={`w-[624px]`}
            alt={`tesla_service`}
            src={`/tesla_service.png`}
        />
        <p className='text-lg font-bold'>Για εργασίες φανοποιίας, συνέχισε εδώ:</p>
        <button 
            className={`px-10 py-3 border rounded-md ${!state?.optionsEligibility?.bodyWork && 'cursor-not-allowed'} border-fadedgrey text-midgrey font-semibold text-sm`}
            disabled={isWorkSelectionLoading || !state?.optionsEligibility?.bodyWork}
            onClick={stepOneTeslaHandler}
            >
            Εργασίες φανοποιίας
        </button>
      </div>
    </>
  );
};
